// extracted by mini-css-extract-plugin
module.exports = {"image":"view-driver_image_1h_89"};